// import action
import { decodeJwt } from "./jsonWebToken";

// import config
import axios, { setAuthorization } from "../config/axios";
import Config from "../config/index";

// import lib
import { setAuthToken } from "../lib/localStorage";

export const login = async (data, dispatch) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/login`,
      data,
    });
    console.log('respData.data----', respData.data.data.data.token)
    if (respData.data.data.status == "TWO_FA") {
      return {
        status: "TWO_FA",
        loading: false,
        message: respData.data.data.message,
      };
    }

    setAuthorization(respData.data.data.data.token);
    setAuthToken(respData.data.data.data.token);
    decodeJwt(respData.data.data.data.token, dispatch);

    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data?.errors,
    };
  }
};
export const adminForgotPassword = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/forgot-Password`,
      data,
    });
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const verifyOtp = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/verify-Admin-Otp`,
      data,
    });
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const adminResetPassword = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/reset-password`,
      data,
    });
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const getAdminList = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `/admin/subAdmin`,
    });

    return {
      status: "success",
      loading: false,
      result: respData.data.result,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
    };
  }
};

export const creatAdmin = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/sub-admin`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const EditAdmin = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/edit-admin`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const EditAdminStatus = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/edit-admin-status`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const getGeoInfoData = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `${Config.getGeoInfo}`,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const loginHisPagination = async (data) => {
  try {
    let respData = await axios({
      method: "get",
      url: `/admin/login-history`,
      params: data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.result,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const changePassword = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/changeAdminPassword`,
      data,
    });

    return {
      status: 'success',
      loading: false,
      message: respData.data.data.message,
      result: respData.data?.data,
    };
  } catch (err) {
    console.log('err.response.data----', err.response.data.data.message)
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.message,
    };
  }
};

export const getProfile = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `/admin/get-profile`,
    });

    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      result: respData.data.result,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const sendMail = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/send-mail`,
      data,
    });

    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      result: respData.data.result,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const editProfile = async (data) => {
  try {
    let respData = await axios({
      method: "put",
      url: `/admin/edit-profile`,
      data,
    });

    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      result: respData.data.result,
    };
  } catch (err) {
    return {
      status: err.response.data.status,
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const getUserList = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/getUserList`,
      data,
    });
    // console.log('respData.data.data.data-----', respData.data.data.data)
    return {
      status: "success",
      loading: false,
      result: respData.data.data.data.userList,
      count: respData.data.data.data.count,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
    };
  }
};


export const getUserSubscribedList = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/planSubscriptionTransaction`,
      data,
    });


    return {
      status: "success",
      loading: false,
      result: respData.data.data.data.transactions,
      count: respData.data.data.data.totalCount,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
    };
  }
};

export const EditUserStatus = async (data) => {
  try {
  
    let respData = await axios({
      method: "post",
      url: `/admin/updateUser`,
      data,
    });
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.errors,
    };
  }
};

export const DeleteSingleUser = async (data) => {
  try {
    console.log('data----', data)
    let respData = await axios({
      method: "post",
      url: `/admin/DeleteSingleUser`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};



export const addNewUser = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/add-Users`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.errors,
      error: err.response.data.errors,
    };
  }
};

export const addNewUserCSV = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/add-Users-CSV`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};


export const addNewCMS = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/addCMS`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.errors,
      error: err.response.data.data.errors,
    };
  }
};

export const EditCMS = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/editCMS`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.errors,
      error: err.response.data.data.errors,
    };
  }
};

export const getAllCMS = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/getCMSList`,
      data,
    });
      console.log('respData.data.data.data----', respData.data.data.data)
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data.cmsData,
      count: respData.data.data.data.totalCount,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};



export const addNewFAQ = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/add-faq`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.errors,
      error: err.response.data.errors,
    };
  }
};

export const EditFAQ = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/edit-faq`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.errors,
      error: err.response.data.errors,
    };
  }
};

export const getAllFAQ = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/get-faq`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      data: respData.data.data,
      count: respData.data.count
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.errors,
      error: err.response.data.errors,
    };
  }
};



export const getEmailTemplates = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/emailTemplateList`,
      data,
    });
    console.log('respData.data.-----', respData.data)
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      data: respData.data.data.data.data,
      count: respData.data.data.count
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
}



export const addEmailTemplate = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/addEmailTemplate`,
      data,
    });
    console.log('respData.data.data----', respData.data.data)
    return {
      status: respData.data.data.status,
      loading: false,
      message: respData.data.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
}

export const editEmailTemplates = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/editEmailTemplate`,
      data,
    });

    return {
      status: respData.data.data.status,
      loading: false,
      message: respData.data.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
}



export const getsubslist = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/getSubsList`,
      data,
    });

    return {
      status: respData.data.data.status,
      loading: false,
      message: respData.data.data.message,
      data: respData.data.data.data
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.errors,
      error: err.response.data.data.errors,
    };
  }
}



export const sendNewsLetter = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/sendNews`,
      data,
    });

    return {
      status: respData.data.data.status,
      loading: false,
      message: respData.data.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.errors,
      error: err.response.data.data.errors,
    };
  }
}


